/**
 * Minimal pub/sub emitter for toast notifications.
 * Lives outside React so that plain modules (like api.ts) can emit toasts
 * without importing React or the Zustand store.
 */

export type ToastType = "error" | "success" | "info";
type Listener = (message: string, type: ToastType) => void;

const listeners = new Set<Listener>();

export function emitToast(message: string, type: ToastType = "error") {
  for (const fn of listeners) fn(message, type);
}

export function onToast(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
